export default __webpack_public_path__ + "static/media/clockSVG.4247706b.svg";